var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      class: {
        "input-group": true,
        "datepick-container": true,
        calendar: _vm.isActive,
      },
    },
    [
      _c("div", { staticClass: "pika-container" }, [
        _vm.isActive
          ? _c("div", { staticClass: "pika-custom" }, [
              _c(
                "div",
                {
                  staticClass: "pika-event-btn today",
                  on: {
                    click: function ($event) {
                      return _vm.customDate("today", $event)
                    },
                  },
                },
                [_vm._v("\n        Today\n      ")]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "pika-event-btn tomorrow",
                  on: {
                    click: function ($event) {
                      return _vm.customDate("tomorrow", $event)
                    },
                  },
                },
                [_vm._v("\n        Tomorrow\n      ")]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "pika-event-btn weekend",
                  on: {
                    click: function ($event) {
                      return _vm.customDate("weekend", $event)
                    },
                  },
                },
                [_vm._v("\n        This Weekend\n      ")]
              ),
            ])
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c("h3", [_vm._v("Start on")]),
      _vm._v(" "),
      _c("input", {
        ref: "input",
        staticClass: "datepicker no-select",
        attrs: {
          disabled: "",
          "aria-labelledby": "datepicker",
          placeholder: "YYYY-MM-DD",
          id: "event-datepicker",
        },
        domProps: { value: _vm.inputValue },
      }),
      _vm._v(" "),
      _c("div", { staticClass: "input-group-append no-select" }, [
        _c(
          "span",
          { staticClass: "input-group-text form-control" },
          [
            _c("img", {
              staticClass: "svg calendar-icon",
              staticStyle: { display: "inline-block" },
              attrs: {
                src: "/app/themes/ucla/resources/assets/images/calendar.svg",
                alt: "calendar",
                width: "16",
                height: "16",
              },
            }),
            _vm._v(" "),
            _c("div", { staticClass: "sr-only" }, [_vm._v("Calendar")]),
            _vm._v(" "),
            _c("chevron-icon"),
            _vm._v(" "),
            _c("div", { staticClass: "sr-only" }, [_vm._v("Dropdown")]),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./scripts/vue/components/DatePicker.vue